import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "sp-6 mx-auto" }
const _hoisted_2 = { class: "w-full mt-4" }
const _hoisted_3 = {
  key: 0,
  class: "multip-select-btn-group bg-white rounded-[50px] p-1 flex justify-between items-center gap-1 max-w-[219px] shadow-[0px_8px_30px_0px_rgba(128,140,163,0.15)] mb-10"
}
const _hoisted_4 = { class: "flex flex-row" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "upload-section mt-8 rounded-[20px] shadow-[0px_8px_30px_0px_rgba(128,140,163,0.15)] py-6 px-8 text-center bg-white"
}
const _hoisted_7 = { class: "mb-6 text-gray-700 text-2xl font-medium" }
const _hoisted_8 = {
  key: 1,
  class: "search-and-load-section mt-8"
}
const _hoisted_9 = { class: "rounded-xl bg-white border border-gray-200" }
const _hoisted_10 = { class: "min-w-full w-full" }
const _hoisted_11 = { class: "columns" }
const _hoisted_12 = { class: "text-start pl-3" }
const _hoisted_13 = ["checked"]
const _hoisted_14 = { class: "flex hover:cursor-pointer gap-1" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "flex hover:cursor-pointer gap-1" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "flex hover:cursor-pointer gap-1" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "flex hover:cursor-pointer gap-1" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "flex hover:cursor-pointer gap-1" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { class: "flex hover:cursor-pointer gap-1" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = { class: "pl-3" }
const _hoisted_45 = ["value"]
const _hoisted_46 = { class: "text-gray-900 font-medium text-sm py-6" }
const _hoisted_47 = { class: "text-gray-600 text-sm py-6" }
const _hoisted_48 = { class: "text-gray-600 text-sm py-6" }
const _hoisted_49 = { class: "text-sm text-gray-600 py-6" }
const _hoisted_50 = { class: "text-sm text-gray-600 py-6" }
const _hoisted_51 = { class: "text-sm text-gray-600 py-6" }
const _hoisted_52 = { class: "grade-block bg-blue-600 w-auto flex justify-between items-center py-2.5 px-5 rounded-lg my-6 mx-3" }
const _hoisted_53 = { class: "learner-count-block text-sm text-blue-600 bg-purple-50 py-1 px-6 rounded-lg" }
const _hoisted_54 = { class: "flex justify-between items-center mt-8" }
const _hoisted_55 = { class: "h-5 w-4 [&>svg]:stroke-current [&>svg]:h-5" }
const _hoisted_56 = {
  key: 1,
  class: "flex items-center"
}
const _hoisted_57 = {
  key: 2,
  class: "flex items-center align-right"
}
const _hoisted_58 = {
  key: 1,
  class: "pagination w-full flex justify-center items-center gap-2 pt-8"
}
const _hoisted_59 = ["onClick"]

import { ref, watch, computed, onMounted, onBeforeMount } from "vue";
import { useLearnerStore } from "@/stores/learnerStore";
import { useFilterStore } from "@/stores/filterStore";
import { useSchoolStore } from "@/stores/schoolStore";
import { useRoute, useRouter } from "vue-router";
import FileUploadWidgetComponent from "@/modules/main/components/FileUploadWidgetComponent.vue";
import SearchAndloadComponent from "@/modules/main/components/internal-tools/SearchAndloadComponent.vue";
import InternalArchiveContentModals from "@/modules/main/components/modals/InternalArchiveContentModals.vue";
import { Learner } from "@/interfaces/learner.interface";
import { NewLearner } from "@/interfaces/new-learner.interface";
import { SchoolStructure } from "@/interfaces/school-structure.interface";

interface SelectOption {
  label: string;
  value: string;
}

// Variables
const itemsPerPage = 20;

export default /*#__PURE__*/_defineComponent({
  __name: 'InternalArchiveContentComponent',
  props: {
    showHiddenButton: {
        type: Boolean,
        required: false,
        default: false,
  },
  searchQuery: {
    type: String,
    required: false,
    default: "",
    }
},
  setup(__props) {

const props = __props;



const loading = ref(false);
const activeButton = ref<string | null>("archiveSelected");
const actionType = ref<string | null>("archived");
const archivemethodSelected = ref<string>();
const showFileUploadModal = ref(false);
const currentClassGroup = ref<any>(null);
const selectedLearners = ref<string[]>([]);
const uploadedLearners = ref<any>([]);
let currentPage = ref(1);
const learnerOptions = ref<SelectOption[]>([]);
const learnersData = ref<any[]>([]);
const uploadPreviewCard = ref(false);
let searchLoadPreviewCard = ref(false);
let archiveRequestSuccess = ref(false);
let archiveRequestFailed = ref(false);
const sortKey = ref('');
const sortOrder = ref('asc');

// Router and Route
const router = useRouter();
const route = useRoute();

// Data Sources
const learnerStore = useLearnerStore();
const schoolStore = useSchoolStore();
const filterStore = useFilterStore();

const filteredLearners = computed(() => {
  const query = props.searchQuery.toLowerCase().trim();
  const selectedClassGroups = filterStore.selectedFilters.classGroup || [];
  const selectedGradeLevel = filterStore.selectedFilters.gradeLevel;
  const selectedSubject = filterStore.selectedFilters.subject;

  const data = learnerStore.getAllSchoolLearners.filter((student) => {
    let typeCondition = false;
    if (activeButton.value === "archiveSelected") {
      typeCondition = (student.status === "active") ? true : false;
    } else if (activeButton.value === "unarchiveSelected") {
      typeCondition = (student.status == "archived") ? true : false;
    }
    const matchesQuery =
      student.firstName.toLowerCase().includes(query) ||
      student.lastName.toLowerCase().includes(query) ||
      student.email.toLowerCase().includes(query);

    const studentClasses = student.classes || [];

    const matchesSubject = selectedSubject
      ? studentClasses.some((cls: { _id?: string; subject?: { _id?: string } | string }) => String((typeof cls.subject === 'object' ? cls.subject?._id : cls.subject) || '') === String(selectedSubject))
      : true;

    const matchesGrade = selectedGradeLevel !== undefined && selectedGradeLevel !== -1
      ? Number(student.grade) === Number(selectedGradeLevel)
      : true;

    const matchesClassGroups = selectedClassGroups.length > 0
      ? studentClasses.some((cls: { _id?: string }) => Boolean(cls._id && selectedClassGroups.includes(cls._id)))
      : true;

    const matchesFilters = selectedClassGroups.length > 0
      ? matchesClassGroups
      : matchesGrade && matchesSubject;

    return typeCondition && matchesQuery && matchesFilters;
  });
  return data;
});

const setActiveButton = (button: string) => {
  selectedLearners.value = [];
  currentPage.value = 1;
  activeButton.value = button;
  actionType.value = button === "archiveSelected" ? "archived" : "unarchived";
  searchLoadPreviewCard.value = false;
  uploadPreviewCard.value = false;
}

const goBack = () => {

  if (props.showHiddenButton) {  
     router.push('/main/internal');
  }else {
    uploadedLearners.value = [];
    archivemethodSelected.value = "";
    uploadPreviewCard.value = false;
  }

  learnerStore.setArchiveOptions(true);
};

const paginatedLearners = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage;
  const end = start + itemsPerPage;
  return filteredLearners.value.slice(start, end);
});

const totalPages = computed(() => {
  return Math.ceil(filteredLearners.value.length / itemsPerPage);
});

const toggleAll = () => {
  if (selectedLearners.value.length === filteredLearners.value.length) {
    selectedLearners.value = [];
  } else {
    selectedLearners.value = filteredLearners.value.map(
      (student) => student._id
    );
  }
};

const areAllSelected = computed(() => {
  return (
    filteredLearners.value.length > 0 &&
    selectedLearners.value.length === filteredLearners.value.length
  );
});

const selectedLearnersData = computed(() => {
  const selectedLearnersArray = Object.values(selectedLearners.value);
  const resp = filteredLearners.value.filter((learner) =>
    selectedLearnersArray.includes(learner._id)
  );
  return resp;
});

const goToPage = (page: number) => {
  currentPage.value = page;
};

const learnerCount = computed(() => {
  return selectedLearners.value.length;
});

onBeforeMount(async () => {
  const learnersData = learnerStore.getAllSchoolLearners;
  learnerOptions.value = learnersData.map((group) => {
    return {
      label: group.firstName + " " + group.lastName,
      value: group._id,
    };
  });
});

const subjects = computed(() => {
  const subjects = new Set();
  learnersData.value.forEach((item) => {
    item.classes?.forEach((classItem: any) => {
      const existingSubject = Array.from(subjects).find(
        (subject :any) => subject._id === classItem.subject._id
      );
      if (!existingSubject) {
        subjects.add(classItem.subject);
      }      
    });
  });
  return Array.from(subjects);
});

watch(
  () => filterStore.selectedFilters,
  async () => {
    currentPage.value = 1;
    learnersData.value = learnerStore.getAllSchoolLearners;
  },
  { deep: true }
);

watch(
  () => props.searchQuery,
  () => {
    currentPage.value = 1;
  }
);

const receiveUploadedLearners = (learners: any) => {
  const filteredData = filteredLearners.value;
  const learnersEmails = learners.map((learner: NewLearner) => learner.email);
  const learnersInFilteredData = filteredData.filter((learner) =>
    learnersEmails.includes(learner.email)
  );
  selectedLearners.value = learnersInFilteredData.map((learner) => learner._id);
  uploadedLearners.value = learnersInFilteredData;
  uploadPreviewCard.value = true;
  searchLoadPreviewCard.value = false;
  archivemethodSelected.value = "";
};

function searchLoadPreview() {
  searchLoadPreviewCard.value = true;
  uploadPreviewCard.value = false;
  archivemethodSelected.value = "";
}

const submitLearnersForUnarchive = async () => {
  loading.value = true;
  const learnerEmails = selectedLearnersData.value.map((learner) => ({ email: learner.email })) as Array<NewLearner>;
  let request = await learnerStore.bulkArchiveUnarchiveLearners("unarchive", learnerEmails);
  loading.value = false;
  if (request?.success === true) {
    archiveRequestSuccess.value = true;
       //reset ui
    searchLoadPreviewCard.value = false;
    uploadPreviewCard.value = false;
    // Clear learners
    selectedLearners.value = [];
  } else {
    archiveRequestFailed.value = true;
  }
};

const submitLearnersForArchive = async () => {
  loading.value = true;
  const learnerEmails = selectedLearnersData.value.map((learner) => ({ email: learner.email }))  as Array<NewLearner>;
  let request = await learnerStore.bulkArchiveUnarchiveLearners("archive", learnerEmails);
  loading.value = false;
  if (request?.success === true) {
    archiveRequestSuccess.value = true;
    searchLoadPreviewCard.value = false;
    uploadPreviewCard.value = false;
    // Clear learners
    selectedLearners.value = [];
  } else {
    archiveRequestFailed.value = true;
  }
};

onBeforeMount(() => {
  const classGroupId = route.params.classId;
  currentClassGroup.value =
    schoolStore.currentSchoolStructure?.classGroups?.find(
      (classGroup) => classGroup._id === classGroupId
    );
});

const sortTable = (key: string) => {
  if (sortKey.value === key) {
    sortOrder.value = sortOrder.value === 'asc' ? 'desc' : 'asc';
  } else {
    sortKey.value = key;
    sortOrder.value = 'asc';
  }

  paginatedLearners.value.sort((a: any, b: any) => {
    let result = 0;
    if (key === 'class') {
      const aClass = a.classes.find((cls :any) => cls.subject._id == filterStore.selectedFilters.subject)?.name || '';
      const bClass = b.classes.find((cls :any) => cls.subject._id == filterStore.selectedFilters.subject)?.name || '';
      if (aClass < bClass) {
        result = -1;
      } else if (aClass > bClass) {
        result = 1;
      }
    } else {
      if (a[key] < b[key]) {
        result = -1;
      } else if (a[key] > b[key]) {
        result = 1;
      }
    }
    return sortOrder.value === 'asc' ? result : -result;
  });
};

onMounted(() => {
  
  learnersData.value = learnerStore.getAllSchoolLearners;
  
  if (window.location.hash === '#unarchive') {
    actionType.value = 'unarchived';
    activeButton.value = "unarchiveSelected"
  }
});


return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_rl_icon = _resolveComponent("rl-icon")!
  const _component_spinner_loader = _resolveComponent("spinner-loader")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (!uploadPreviewCard.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("button", {
                class: _normalizeClass(["rounded-[50px] py-2 px-6 font-semibold shadow-none outline-none transition text-sm", {
              'bg-blue-600 text-white transition':
                activeButton.value === 'archiveSelected',
              'text-gray-500 transition': activeButton.value !== 'archiveSelected',
            }]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (setActiveButton('archiveSelected')))
              }, _toDisplayString(_ctx.$t("archive_flow.archive_btn")), 3),
              _createElementVNode("button", {
                class: _normalizeClass(["rounded-[50px] py-2 px-6 font-semibold shadow-none outline-none transition text-sm", {
              'bg-blue-600 text-white transition':
                activeButton.value === 'unarchiveSelected',
              'text-gray-500 transition': activeButton.value !== 'unarchiveSelected',
            }]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (setActiveButton('unarchiveSelected')))
              }, _toDisplayString(_ctx.$t("archive_flow.unarchive_btn")), 3)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          (!uploadPreviewCard.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_FormKit, {
                  modelValue: archivemethodSelected.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((archivemethodSelected).value = $event)),
                  type: "radio",
                  options: [
                _ctx.$t('archive_flow.upload'),
                _ctx.$t('archive_flow.search_and_load'),
              ],
                  "wrapper-class": {
                'text-gray-500': true,
              },
                  classes: {
                inner: {
                  'me-2': true,
                },
              }
                }, null, 8, ["modelValue", "options"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (archivemethodSelected.value === _ctx.$t('archive_flow.upload'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.$t("archive_flow.upload_header")), 1),
            (_unref(schoolStore).currentSchool)
              ? (_openBlock(), _createBlock(FileUploadWidgetComponent, {
                  key: 0,
                  uploadType: 'archive_unarchive',
                  classGroupId: currentClassGroup.value,
                  subjects: (subjects.value as any),
                  shouldGenerateEmail: false,
                  schoolData: _unref(schoolStore).currentSchool,
                  schoolStructure: (_unref(schoolStore).getSchoolStructure as SchoolStructure),
                  onCloseUploadModal: _cache[3] || (_cache[3] = ($event: any) => (showFileUploadModal.value = false)),
                  onTransmitLearnersToUpload: receiveUploadedLearners,
                  requireGrade: false,
                  lockedJourneys: false,
                  class: "max-w-3xl m-auto"
                }, null, 8, ["classGroupId", "subjects", "schoolData", "schoolStructure"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (archivemethodSelected.value === _ctx.$t('archive_flow.search_and_load'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("table", _hoisted_10, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", _hoisted_11, [
                    _createElementVNode("th", _hoisted_12, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        onChange: toggleAll,
                        checked: areAllSelected.value,
                        class: "h-4 w-4 border border-blue-600 text-blue-600 focus:ring-blue-600"
                      }, null, 40, _hoisted_13)
                    ]),
                    _createElementVNode("th", {
                      class: "text-start text-gray-600 font-medium text-xs py-3",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (sortTable('firstName')))
                    }, [
                      _createElementVNode("span", _hoisted_14, [
                        _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.learners_table.first_name")), 1),
                        _hoisted_15,
                        (sortKey.value === 'firstName'|| sortKey.value === '')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                              (sortOrder.value === 'asc')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_17, " ▲ "))
                                : (_openBlock(), _createElementBlock("span", _hoisted_18, " ▼ "))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("th", {
                      class: "text-start text-gray-600 font-medium text-xs py-3",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (sortTable('lastName')))
                    }, [
                      _createElementVNode("span", _hoisted_19, [
                        _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.learners_table.last_name")), 1),
                        _hoisted_20,
                        (sortKey.value === 'lastName'|| sortKey.value === '')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                              (sortOrder.value === 'asc')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_22, " ▲ "))
                                : (_openBlock(), _createElementBlock("span", _hoisted_23, " ▼ "))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("th", {
                      class: "text-start text-gray-600 font-medium text-xs py-3",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (sortTable('grade')))
                    }, [
                      _createElementVNode("span", _hoisted_24, [
                        _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.learners_table.grade")), 1),
                        _hoisted_25,
                        (sortKey.value === 'grade'|| sortKey.value === '')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                              (sortOrder.value === 'asc')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_27, " ▲ "))
                                : (_openBlock(), _createElementBlock("span", _hoisted_28, " ▼ "))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("th", {
                      class: "text-start text-gray-600 font-medium text-xs py-3",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (sortTable('email')))
                    }, [
                      _createElementVNode("span", _hoisted_29, [
                        _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.learners_table.email")), 1),
                        _hoisted_30,
                        (sortKey.value === 'email'|| sortKey.value === '')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_31, [
                              (sortOrder.value === 'asc')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_32, " ▲ "))
                                : (_openBlock(), _createElementBlock("span", _hoisted_33, " ▼ "))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("th", {
                      class: "text-start text-gray-600 font-medium text-xs py-3",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (sortTable('class')))
                    }, [
                      _createElementVNode("span", _hoisted_34, [
                        _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.learners_table.class")), 1),
                        _hoisted_35,
                        (sortKey.value === 'class'|| sortKey.value === '')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_36, [
                              (sortOrder.value === 'asc')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_37, " ▲ "))
                                : (_openBlock(), _createElementBlock("span", _hoisted_38, " ▼ "))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("th", {
                      class: "text-start text-gray-600 font-medium text-xs py-3",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (sortTable('status')))
                    }, [
                      _createElementVNode("span", _hoisted_39, [
                        _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.learners_table.status")), 1),
                        _hoisted_40,
                        (sortKey.value === 'status'|| sortKey.value === '')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_41, [
                              (sortOrder.value === 'asc')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_42, " ▲ "))
                                : (_openBlock(), _createElementBlock("span", _hoisted_43, " ▼ "))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedLearners.value, (student) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: student._id,
                      class: _normalizeClass([{
                  'bg-soft-purple': selectedLearners.value.includes(student._id),
                }, "mb-1"])
                    }, [
                      _createElementVNode("td", _hoisted_44, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          value: student._id,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((selectedLearners).value = $event)),
                          class: "h-4 w-4 border border-blue-600 text-blue-600 focus:ring-blue-600"
                        }, null, 8, _hoisted_45), [
                          [_vModelCheckbox, selectedLearners.value]
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_46, _toDisplayString(student.firstName), 1),
                      _createElementVNode("td", _hoisted_47, _toDisplayString(student.lastName), 1),
                      _createElementVNode("td", _hoisted_48, _toDisplayString(student.grade), 1),
                      _createElementVNode("td", _hoisted_49, _toDisplayString(student.email), 1),
                      _createElementVNode("td", _hoisted_50, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((student.classes || []).filter((cls) => cls.subject._id == _unref(filterStore).selectedFilters.subject), (classItem) => {
                          return (_openBlock(), _createElementBlock("span", {
                            class: "rounded-[50px] py-1 px-2 mr-1 shadow-none outline-none text-xs bg-blue-600 text-white",
                            key: classItem._id
                          }, _toDisplayString(classItem.name), 1))
                        }), 128))
                      ]),
                      _createElementVNode("td", _hoisted_51, [
                        _createElementVNode("strong", null, _toDisplayString(student.status), 1)
                      ])
                    ], 2))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, _toDisplayString(learnerCount.value) + " " + _toDisplayString(_ctx.$t("archive_flow.selected")), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_unref(searchLoadPreviewCard) && archivemethodSelected.value === '' || uploadPreviewCard.value && archivemethodSelected.value === '')
      ? (_openBlock(), _createBlock(SearchAndloadComponent, {
          key: 0,
          uploadPreviewCard: uploadPreviewCard.value,
          archivemethodSelected: archivemethodSelected.value,
          actionType: actionType.value || '',
          uploadedLearners: uploadedLearners.value,
          searchLoadPreviewCard: _unref(searchLoadPreviewCard),
          selectedLearnersData: selectedLearnersData.value
        }, null, 8, ["uploadPreviewCard", "archivemethodSelected", "actionType", "uploadedLearners", "searchLoadPreviewCard", "selectedLearnersData"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_54, [
      (__props.showHiddenButton)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[11] || (_cache[11] = ($event: any) => (goBack())),
            class: "font-semibold text-gray-700 text-base border-gray-300 border rounded-lg ms-10 py-2 px-4 flex items-center shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] bg-white"
          }, [
            _createElementVNode("span", _hoisted_55, [
              _createVNode(_component_rl_icon, {
                icon: 'rl-small-back-arrow',
                title: 'rl small back arrow',
                "aria-hidden": "true"
              })
            ]),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("archive_flow.back")), 1)
          ]))
        : _createCommentVNode("", true),
      (archivemethodSelected.value === _ctx.$t('archive_flow.search_and_load'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
            _createElementVNode("button", {
              onClick: _cache[12] || (_cache[12] = ($event: any) => (goBack())),
              class: "font-semibold text-gray-700 text-base border-gray-300 border rounded-lg py-2 px-4 font-medium flex items-center bg-transparent me-4 shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] bg-white"
            }, _toDisplayString(_ctx.$t("archive_flow.cancel")), 1),
            _createElementVNode("button", {
              onClick: searchLoadPreview,
              class: "rounded-lg py-2 px-4 text-white flex items-center font-semibold bg-blue-600 shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)]"
            }, _toDisplayString(_ctx.$t("archive_flow.preview_selection")), 1)
          ]))
        : _createCommentVNode("", true),
      (
          _unref(searchLoadPreviewCard) ||
          (uploadPreviewCard.value && archivemethodSelected.value === '')
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
            _createElementVNode("button", {
              onClick: _cache[13] || (_cache[13] = ($event: any) => (goBack())),
              class: "font-semibold text-gray-700 text-base border-gray-300 border rounded-lg py-2 px-4 font-medium flex items-center bg-transparent me-4 shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] bg-white"
            }, _toDisplayString(_ctx.$t("archive_flow.cancel")), 1),
            (activeButton.value == 'archiveSelected')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: submitLearnersForArchive,
                  class: "rounded-lg py-2 px-4 text-white flex items-center font-semibold bg-blue-600 shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)]"
                }, [
                  (loading.value)
                    ? (_openBlock(), _createBlock(_component_spinner_loader, {
                        key: 0,
                        color: 'text-white dark:text-white mr-2'
                      }))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("archive_flow.archive_students")), 1)
                ]))
              : _createCommentVNode("", true),
            (activeButton.value == 'unarchiveSelected')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  onClick: submitLearnersForUnarchive,
                  class: "rounded-lg py-2 px-4 text-white flex items-center font-semibold bg-blue-600 shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)]"
                }, [
                  (loading.value)
                    ? (_openBlock(), _createBlock(_component_spinner_loader, {
                        key: 0,
                        color: 'text-white dark:text-white mr-2'
                      }))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("archive_flow.unarchive_students")), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    (archivemethodSelected.value === _ctx.$t('archive_flow.search_and_load'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(totalPages.value, (page) => {
            return (_openBlock(), _createElementBlock("button", {
              key: page,
              class: _normalizeClass(["text-tertiary rounded-sm p-2 text-sm font-medium w-6 h-6 leading-none flex justify-center items-center", { '!text-dark-blue': _unref(currentPage) === page }]),
              onClick: ($event: any) => (goToPage(page))
            }, _toDisplayString(page), 11, _hoisted_59))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_unref(archiveRequestSuccess) || _unref(archiveRequestFailed))
      ? (_openBlock(), _createBlock(InternalArchiveContentModals, {
          key: 2,
          archiveRequestSuccess: _unref(archiveRequestSuccess),
          archiveRequestFailed: _unref(archiveRequestFailed),
          actionType: actionType.value || '',
          onCloseSuccessFailModal: _cache[14] || (_cache[14] = ($event: any) => {_isRef(archiveRequestSuccess) //@ts-ignore
 ? archiveRequestSuccess.value = false : archiveRequestSuccess = false; _isRef(archiveRequestFailed) //@ts-ignore
 ? archiveRequestFailed.value = false : archiveRequestFailed = false;})
        }, null, 8, ["archiveRequestSuccess", "archiveRequestFailed", "actionType"]))
      : _createCommentVNode("", true)
  ]))
}
}

})